/**
=========================================================
* Soft UI Dashboard React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-material-ui
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

// Redux
import { useDispatch } from "react-redux";
import { logOut } from "state/auth/authSlice";
import { resetCommunity } from "state/communities/communitiesSlice";
import { useLogoutMutation } from "state/auth/authApiSlice";
import apiSlice from "state/api/apiSlice";

function SignOut() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [logout] = useLogoutMutation();

  const handleLogout = async () => {
    try {
      // Call backend to invalidate Keycloak refresh token
      await logout().unwrap();
    } catch (error) {
      // Continue with local logout even if backend call fails
      // Error is silently handled as logout should always succeed locally
    }

    // Clear auth state
    dispatch(logOut());

    // Clear community state
    dispatch(resetCommunity());

    // Clear persisted storage
    localStorage.removeItem("persist:root");

    // Reset all RTK Query cache
    dispatch(apiSlice.util.resetApiState());

    // Navigate to signin
    return navigate(`/signin`);
  };

  useEffect(() => {
    handleLogout();
  }, []);

  return null;
}

export default SignOut;
